<template>
  <div>
    <div
      class="hidden relative lg:flex items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full"
    >
      <div class="px-12">
        <p class="text-4xl text-gray-900">Aide</p>
        <p
          class="mt-2 text-base font-light leading-4 2xl:leading-5 text-gray-600"
        >
          Formulaire de contact
        </p>
      </div>
      <illustration
        name="help"
        class="hidden xl:block absolute right-5 xl:right-10 w-60 xl:w-72"
      />
    </div>

    <!-- Contenu -->
    <div
      v-if="$can(constants.PERMISSION_AIDE_CONSULTER)"
      class="flex flex-col mt-16 mb-8"
    >
      <MessageHeader :message-header="$store.state.help.messageHeader" />

      <div
        class="relative align-middle min-w-full shadow sm:rounded-lg border-b border-gray-200 bg-white pb-10 table min-h-halfscreen"
      >
        <router-view />
      </div>
    </div>
    <page-not-allowed v-else />
    <!-- Fin Contenu -->
  </div>
</template>

<script>
import Illustration from './../../components/Illustration';
import MessageHeader from '../../components/MessageHeader';
import PageNotAllowed from '../../components/PageNotAllowed';

import Constants from './../../constants';

export default {
  name: 'Account',

  components: {
    MessageHeader,
    Illustration,
    PageNotAllowed,
  },

  data() {
    return {
      constants: Constants,
    };
  },
};
</script>
